import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=1329e98a&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=1329e98a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1329e98a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1329e98a')) {
      api.createRecord('1329e98a', component.options)
    } else {
      api.reload('1329e98a', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=1329e98a&scoped=true&", function () {
      api.rerender('1329e98a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/marketingQR/Edit.vue"
export default component.exports